export const classes = {
  input: 'hidden',
};
